/**
 * Rounds a float up or down to the requested decimal place.
 *
 * @param {number} float
 * @returns {string}
 */
export var roundToDecimalPlace = function roundToDecimalPlace(float, decimalPlaces) {
  var roundedVal = typeof float === 'number' ? float.toFixed(decimalPlaces) : '0';
  return roundedVal;
};